/**
 * @file routes/routeLoader.ts
 * @description lazy loading of routes.
 *
 * @author ogarcia (ozkary)
 *
 */ /**
 * Use this route loader when using lazy loading and dynamic imports
 * @param factory function for dynamic load of routes
 * @param maxRetry number of retries
 * @returns a page container
 */ // https://www.ozkary.com/2021/11/react-static-web-apps-chunk-load-error.html
var retryLoader=function retryLoader(factory){var maxRetry=arguments.length>1&&arguments[1]!==undefined?arguments[1]:2;var interval=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1000;//console.log('routeLoader')
return new Promise(function(resolve,reject){factory().then(resolve).catch(function(error){if(maxRetry===0){reject(error);// this is probably a white page error. reload the main page
// alt - add better messaging or load another page
// window.location.reload();
console.debug('retryLoader.:routeLoader.:error=',error);return;}// recursively try again reducing the retry count
var timer=setTimeout(function(){retryLoader(factory,--maxRetry).then(resolve,reject);clearTimeout(timer);},interval);});});};export default retryLoader;